<template>
  <div ref="loading_cont" tabindex="-1" :class="[loading_noopacity ? 'grcdb-loading-noopacity' : 'grcdb-loading', loading_visible>0 ? 'grcdb-loading-visible' : 'grcdb-loading-hidden']" 
        v-bind:style="{ 'left': loading_left, 'top': loading_top, 'width':loading_width+'px', 'height':loading_height+'px' }"
        @keydown="LoadingKeydown"
  >
        <table class="grcdb-loading-table" cellspacing="0" cellpadding="0">
            <tr>
                <td style="text-align:center;">
                  <i class="fas fa-spin"><img class="imgloader" /></i>
                </td>
            </tr>
        </table>
  </div>
</template>


<script>

import Vue from 'vue';
import axios from "axios";

export default {
  name: 'GrcDB',
  components:
  {

  },
  props: {
  },
  data () {
    return {
        loading_left:0,
        loading_top:0,
        loading_width:800,
        loading_height:800,
        loading_visible: 0,
        loading_noopacity: false
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  updated: function() {

    this.$nextTick(function () {
      if (this.loading_visible == 1)
      {
        this.loading_visible = 2;
        this.$refs.loading_cont.focus();        
      }
    });
  },

  methods: {

    async SetLang(pLang)
    {
        var Q = "";
        var resobject;
        await axios.post(GRCDB_WSLANG, {
            pValue: pLang
        }).then(res => { resobject = res; })
        .catch(error => { 
          resobject = error; 
        });

      return resobject;
    },

    async SetEmailCookie(pValue)
    {
        var Q = "";
        var resobject;
        await axios.post(GRCDB_WSEMAIL, {
            pValue: pValue
        }).then(res => { resobject = res; })
        .catch(error => { 
          resobject = error; 
        });

      return resobject;
    },

    async GetData(pWSFunctionName, pParams)
    {
        var XmlParams = "";
        
        for (var key in pParams) {
            XmlParams = XmlParams + GRCDB_GetXmlFormat(key, pParams[key]);
        }

        if (XmlParams != "")
        {
            XmlParams = "<PARAMS>" + XmlParams + "</PARAMS>";
            XmlParams = GRCDB_AddDataSetFrame(XmlParams);
        }

        
        var resobject;
        await this.SrvComm(pWSFunctionName, XmlParams)
        .then(res => { 
          resobject = JSON.parse(res.data.d); 
        })
        .catch(error => { 
          resobject = GRCDB_MakeErrorObject(error); 
        });

        return resobject;
    },


    ExcelDownload(pWSFunctionName, pParams, pFieldList, pExportFileName)
    {
        var XmlParams = "";
        
        for (var key in pParams) {
            XmlParams = XmlParams + GRCDB_GetXmlFormat(key, pParams[key]);
        }

        if (XmlParams != "")
        {
            XmlParams = "<PARAMS>" + XmlParams + "</PARAMS>";
            XmlParams = GRCDB_AddDataSetFrame(XmlParams);
        }

        var myForm = document.createElement("form");
        myForm.method = "post";
        myForm.action = "GeneralExport.aspx";
        myForm.target = "_blank";
        var myInput;

        myInput = document.createElement("input");
        myInput.setAttribute("name", "pFunctionName");
        myInput.setAttribute("value", pWSFunctionName);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "pParams");
        myInput.setAttribute("value", GRCDB_MakePostableStringForDownload(XmlParams));
        myForm.appendChild(myInput);

        /*
        myInput = document.createElement("input");
        myInput.setAttribute("name", "pSessionID");
        myInput.setAttribute("value", GetSessionID());
        myForm.appendChild(myInput);
        */

        myInput = document.createElement("input");
        myInput.setAttribute("name", "pExportFileName");
        myInput.setAttribute("value", pExportFileName);
        myForm.appendChild(myInput);

        myInput = document.createElement("input");
        myInput.setAttribute("name", "pFieldList");
        myInput.setAttribute("value", pFieldList);
        myForm.appendChild(myInput);

        document.body.appendChild(myForm);
        myForm.submit();
        document.body.removeChild(myForm);



    },

    async SrvComm(pWSFunctionName, pParams)
      {
        return axios.post(GRCDB_WSPREFIX, {
            pFunctionName: pWSFunctionName,
            pAppVersion: GRCAPP_AppVersion,
            pParams: pParams,
            pXLMS: gXLMS
        });
    }, // end: SrvComm

    ShowLoading(pNoOpacity)
    {
        this.loading_noopacity = pNoOpacity;
        var bs = grccomp_getBodySize();
        this.loading_width = bs.width;
        this.loading_height = bs.height;
        this.loading_visible = 1;
    },

    HideLoading()
    {
        this.loading_visible = 0;
    },

    LoadingKeydown(e)
    {
      e.preventDefault();
      e.stopPropagation();
    },



    
  }  // end: methods



}
</script>

<style scoped>

.imgloader
{
  content: var(--dbloading_image);
}

</style>